import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchBannedIps } from "../../../actions/mine_craft/bannedIpsActions";
import { setNewParams } from "../../../store/mine_craft/bannedIpsSlice";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import New from "./New";
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import NavBarThree from "../../../componets/NavBarThree";
import Can from "../../../componets/Can";
import { PlusOutlined } from "@ant-design/icons";
import './style.scss';

const LIMIT = 42;

const BannedIps = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order']
    );

    dispatch(fetchBannedIps(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { permanent: true };
    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-banned-ips'>
      <PageHeader title='Banned IPs' />

      <Can capability='write_minecraft'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
              <PlusOutlined /> Ban IP
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            orderBy={{
              defaultKey: 'id',
              items: [
                { name: 'Date', key: 'id' },
                { name: 'Updated', key: 'updated_at' },
              ]
            }}
          />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default BannedIps;
